import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Fade,
  FormControl,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Stack,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepIconProps,
  StepLabel,
  Stepper,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useDropzone } from "react-dropzone";
import { LOCALE } from "../utils/locale";
import {
  DROPZONE,
  DROPZONE_WRAPPER,
  PRODUCT_WRAPPER,
  UPLOAD_CONTAINER,
  UPLOAD_DROP_TEXT,
  UPLOAD_SUBTITLE,
  UPLOAD_BUTTON,
  UPLOAD_DEL_BTN,
  UPLOAD_FILE_NAME,
  UPLOAD_FILE_SIZE,
  UPLOAD_DATA_CONTAINER,
  DROPZONE_FILE,
  UPLOAD_FILTER_BUTTON,
  UPLOAD_FILTER_PAPER,
  UPLOAD_LIST_ITEM,
  UPLOAD_DATE_FILTER_PAPER,
  UPLOAD_TITLE,
  UPLOAD_OVERVIEW_CAPTION,
  USER_MENU_ITEM,
  UPLOAD_NAVIGATION_BTN_ALT,
  UPLOAD_RESET_BTN,
  UPLOAD_CAPTION,
  UPLOAD_INFO_WRAPPER,
  UPLOAD_WARNING_WRAPPER,
  UPLOAD_SUCCESS_WRAPPER,
  UPLOAD_YES_BTN,
  UPLOAD_CANCEL_BTN,
  ENQUEUE_NUMBER,
} from "./styles";

import EXCEL_ICON from "../assets/icons/excel.png";
import CSV_ICON from "../assets/icons/csv.png";
import UPLOAD_ICON from "../assets/icons/upload-outline.png";
import UPLOAD_GIF from "../assets/images/upload.gif";
import SUCCESS_GIF from "../assets/images/Success.gif";
import ERROR_GIF from "../assets/images/Error.gif";
import DATA_GIF from "../assets/images/data.gif";
import FILES_ICON from "../assets/images/files.png";
import RECORDS_ICON from "../assets/images/records.png";
import TRASH_ICON from "../assets/icons/trash.png";
import {
  ArrowDropDown,
  CalendarTodayOutlined,
  CheckCircle,
  CloudUploadOutlined,
  Done,
  DynamicFeed,
  East,
  Error,
  ErrorOutline,
  InfoOutlined,
  RadioButtonUnchecked,
  TrendingDown,
  TrendingUp,
  WarningAmber,
} from "@mui/icons-material";
import { useMsal, useAccount } from "@azure/msal-react";
import {
  getEnqueuedFiles,
  getS3PresignedURL,
  getUploadedFiles,
  getUploadFileStatus,
  getUploadOverview,
  proceedUpload,
} from "../services/upload";
import _ from "lodash";
import { endOfMonth, format, isValid, startOfMonth } from "date-fns";
import { useNavigate } from "react-router-dom";
import { FILE_STATUS_INTERVAL } from "../utils/constants";
import { ROUTES } from "../routes/constants";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import { ordinalSuffixOf } from "../services/helper";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#6DB144",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#6DB144",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#B9BCC5",
    borderTopWidth: 1,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")<{ ownerState: { active?: boolean } }>(
  ({ theme, ownerState }) => ({
    color: "#B9BCC5",
    display: "flex",
    height: 22,
    alignItems: "center",
    ...(ownerState.active && {
      color: "#B9BCC5",
    }),
    "& .QontoStepIcon-completedIcon": {
      color: "#0F3D61",
      zIndex: 1,
      fontSize: 24,
    },
    "& .QontoStepIcon-activeIcon": {
      zIndex: 1,
      fontSize: 24,
    },
    "& .QontoStepIcon-errorIcon": {
      color: "#CE0636",
      zIndex: 1,
      fontSize: 24,
    },
  })
);

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className, error } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <CheckCircle className="QontoStepIcon-completedIcon" />
      ) : error ? (
        <ErrorOutline className="QontoStepIcon-errorIcon" />
      ) : (
        <RadioButtonUnchecked className="QontoStepIcon-activeIcon" />
      )}
    </QontoStepIconRoot>
  );
}

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: "4px",
    position: "relative",
    backgroundColor: "rgba(255, 255, 255, 0.54)",
    border: "1px solid #F1F2F3",
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: 400,
    color: "#686C7E",
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      boxShadow: "none",
      borderColor: "1px solid #F1F2F3",
    },
  },
}));

const BAR_CHART_OPTIONS = {
  parsing: {
    xAxisKey: "date",
    yAxisKey: "value",
  },
  plugins: {
    legend: {
      display: false,
    },
  },
  color: "#282C36",
  maxBarThickness: 24,
  scales: {
    x: {
      grid: {
        display: false,
      },
      border: {
        display: false,
      },
      ticks: {
        font: {
          size: 9,
          weight: "600",
        },
      },
    },
    y: {
      grid: {
        display: false,
      },
      display: false,
    },
  },
  elements: {
    bar: {
      borderRadius: {
        topLeft: 4,
        topRight: 4,
        bottomLeft: 0,
        bottomRight: 0,
      },
    },
  },
};

const SUCCESS_STATUS = "Posted Successfully";
const ERROR_STATUS = "Error";
const RANGE_LIST = [
  "Last 7 Days",
  "Last 30 Days",
  "This Month",
  "Last Month",
  "Custom Range",
];

let INITIAL_CALL = true;

const Upload = () => {
  const { accounts } = useMsal();
  const account: any = useAccount(accounts[0] || {});
  const navigate = useNavigate();

  const [selectedFile, setSelectedFile] = React.useState<any>(null);
  const [uploaders, setUploaders] = React.useState<string[]>([]);
  const [filteredUploaders, setFilteredUploaders] = React.useState<string[]>(
    []
  );
  const [uploadedFiles, setUploadedFiles] = React.useState<any[]>([]);
  const [processStarted, setProcessStarted] = React.useState<boolean>(false);
  const [uploadSteps, setUploadSteps] = React.useState([
    "Uploading",
    "Process",
    "Waiting",
  ]);
  const [activeProcessStep, setActiveProcessStep] = React.useState(-1);
  const [ETag, setETag] = React.useState<string | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [anchorElUploader, setAnchorElUploader] =
    React.useState<HTMLButtonElement | null>(null);
  const [openUploaderFilter, setOpenUploaderFilter] = React.useState(false);
  const [selectedUploaders, setSelectedUploaders] = React.useState<string[]>(
    []
  );
  const [uploadFilters, setUploadFilters] = React.useState<any>({});
  const [anchorElDate, setAnchorElDate] =
    React.useState<HTMLButtonElement | null>(null);
  const [openDateFilter, setOpenDateFilter] = React.useState(false);
  const [startDate, setStartDate] = React.useState<any>({
    date: null,
    minDate: null,
    maxDate: null,
  });
  const [endDate, setEndDate] = React.useState<any>({
    date: null,
    minDate: null,
    maxDate: null,
  });

  const [isOverviewLoading, setIsOverviewLoading] =
    React.useState<boolean>(false);
  const [overviewFilters, setOverviewFilters] = React.useState<any>({
    StartDate: format(Date.now() - 7 * 24 * 60 * 60 * 1000, "MM/dd/yyyy"),
    EndDate: format(new Date(), "MM/dd/yyyy"),
  });
  const [overviewFile, setOverviewFile] = React.useState<any>({
    total: null,
    data: [],
    comparison: null,
  });
  const [overviewUPC, setOverviewUPC] = React.useState<any>({
    total: null,
    data: [],
  });
  const [anchorElRange, setAnchorElRange] =
    React.useState<HTMLButtonElement | null>(null);
  const [openRangeFilter, setOpenRangeFilter] = React.useState(false);
  const [selectedRange, setSelectedRange] = React.useState<number>(0);
  const [rangeLabel, setRangeLabel] = React.useState<string>(
    `${format(Date.now() - 7 * 24 * 60 * 60 * 1000, "MMM d, yyyy")} - ${format(
      new Date(),
      "MMM d, yyyy"
    )}`
  );
  const [enqueuedFiles, setEnqueuedFiles] = React.useState<any[]>([]);
  const [fileProcessStatus, setFileProcessStatus] = React.useState<
    string | null
  >("Started");
  const [processRemarks, setProcessRemarks] = React.useState<any>({
    errors: [],
    warnings: [],
  });
  const [processStatistics, setProcessStatistics] = React.useState<any>({
    totalRecords: "0",
    validRecords: "0",
    otherRecords: "0",
  });
  const [fileID, setFileID] = React.useState<string | null>(null);
  const [enqueuePos, setEnqueuePos] = React.useState<number>(0);
  const [isSourceFile, setIsSourceFile] = React.useState<boolean>(true);
  const [processLoading, setProcessLoading] = React.useState<boolean>(false);

  const onDrop = React.useCallback((acceptedFiles: any[]) => {
    const tempFiles: any[] = [];
    // eslint-disable-next-line
    acceptedFiles.map((file: any) => {
      tempFiles.push(file);
    });
    setSelectedFile(tempFiles[0]);
  }, []);

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    onDrop,
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
      "text/csv": [],
    },
    multiple: false,
  });

  const getInitialFiles = async () => {
    try {
      const files = await getUploadedFiles({});
      if (files?.statusCode === 200) {
        const tempFiles = files?.body?.items || [];
        if (_.size(tempFiles) > 0) {
          const tempUsers: string[] = ["All Users"];
          const tempFilteredFiles: any[] = [];
          tempFiles.map((f: any) => {
            if (f?.FileStatus === "Completed") {
              tempFilteredFiles.push(f);
              tempUsers.push(f.UploadedBy);
            }
            return f;
          });
          setUploaders(_.uniq(tempUsers));
          setFilteredUploaders(_.uniq(tempUsers));
          setUploadedFiles(tempFilteredFiles);
        }
      } else {
        setUploaders([]);
        setFilteredUploaders([]);
        setUploadedFiles([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("[getInitialFiles]: ", error);
      setIsLoading(false);
    } finally {
      INITIAL_CALL = false;
    }
  };

  const getFiles = async () => {
    try {
      setIsLoading(true);
      const files = await getUploadedFiles(uploadFilters);
      if (files?.statusCode === 200) {
        const tempFiles = files?.body?.items || [];
        const tempFilteredFiles: any[] = [];
        if (_.size(tempFiles) > 0) {
          tempFiles.map((f: any) => {
            if (f?.FileStatus === "Completed") {
              tempFilteredFiles.push(f);
            }
            return f;
          });
        }
        setUploadedFiles(tempFilteredFiles);
      } else {
        setUploadedFiles([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("[getFiles]: ", error);
      setIsLoading(false);
    }
  };

  const getUploadStatistics = async () => {
    try {
      setIsOverviewLoading(true);
      const overview = await getUploadOverview(overviewFilters);
      if (overview?.statusCode === 200) {
        const tempFilesData =
          _.get(overview, "body.uploadedfiledetails.items", []) || [];
        let fileChartData: any[] = [];
        if (tempFilesData.length > 0) {
          tempFilesData.forEach((fd: any) => {
            const tempItem = {
              date: format(new Date(fd.date), "dd/MM"),
              value: fd.value,
            };
            fileChartData.push(tempItem);
          });
        }
        setOverviewFile({
          total: _.get(overview, "body.uploadedfiledetails.totalFiles", 0) || 0,
          data: fileChartData,
          comparison:
            _.get(overview, "body.uploadedfiledetails.change", null) || null,
        });
        const tempUPCData = _.get(overview, "body.upcdetails.items", []) || [];
        let upcChartData: any[] = [];
        if (tempUPCData.length > 0) {
          tempUPCData.forEach((ud: any) => {
            const tempItem = {
              date: format(new Date(ud.date), "dd/MM"),
              value: ud.value,
            };
            upcChartData.push(tempItem);
          });
        }
        setOverviewUPC({
          total: _.get(overview, "body.upcdetails.totalFiles", 0) || 0,
          data: upcChartData,
          comparison: _.get(overview, "body.upcdetails.change", null) || null,
        });
      } else {
        setOverviewFile({
          total: null,
          data: [],
          comparison: null,
        });
        setOverviewUPC({
          total: null,
          data: [],
        });
      }
      setIsOverviewLoading(false);
    } catch (error) {
      console.error("[getUploadStatistics]: ", error);
      setIsOverviewLoading(false);
    }
  };

  const getEnqueuedData = async () => {
    try {
      const files = await getEnqueuedFiles();
      if (files?.statusCode === 200) {
        setEnqueuedFiles(files?.body?.body || []);
      } else {
        setEnqueuedFiles([]);
      }
    } catch (error) {
      console.error("[getEnqueuedData]: ", error);
    }
  };

  React.useEffect(() => {
    getEnqueuedData();
    getInitialFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!INITIAL_CALL) {
      getFiles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadFilters]);

  React.useEffect(() => {
    let FINAL_STATUS = "";
    const uploadInterval = setInterval(async () => {
      if (ETag) {
        const ETagParam = ETag.includes("#")
          ? ETag.replaceAll("#", "%23")
          : ETag;
        const status: any = await getUploadFileStatus(ETagParam);
        if (status?.statusCode === 200) {
          const data = status?.body || null;
          if (!_.isEmpty(data)) {
            setFileProcessStatus(data?.FileStatus);
            setProcessRemarks({
              errors: data?.Remarks?.Error || [],
              warnings: data?.Remarks?.Warning || [],
            });
            if (data?.FileStatus === "Validated") {
              if (data?.Remarks?.Warning.length > 0) {
                setProcessStatistics({
                  totalRecords: data?.TotalRecords,
                  validRecords: data?.ValidRecords,
                  otherRecords: data?.OtherRecords,
                });
              }
              setIsSourceFile(data?.IsSourceFile === "1" ? true : false);
            }

            if (data?.FileStatus === "Waiting") {
              setProcessLoading(false);
              setEnqueuePos(data?.Enqueue ? parseInt(data?.Enqueue) : 0);
            }
            if (
              data?.FileStatus === "Validated" ||
              data.FileStatus === "Completed" ||
              data.FileStatus === "Error"
            ) {
              setETag(null);
              if (data?.FileStatus !== "Validated") {
                setUploadSteps(["Uploaded", "Processed", "Waiting"]);
                setActiveProcessStep(2);
                if (data.FileStatus === "Completed") {
                  FINAL_STATUS = SUCCESS_STATUS;
                } else if (data.FileStatus === "Error") {
                  FINAL_STATUS = ERROR_STATUS;
                }
                setTimeout(async () => {
                  setUploadSteps(["Uploaded", "Processed", FINAL_STATUS]);
                  setETag(null);
                  await getEnqueuedData();
                  await getInitialFiles();
                  await getUploadStatistics();
                }, 3000);
              }
            }
          }
        }
      }
    }, FILE_STATUS_INTERVAL);
    return () => clearInterval(uploadInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ETag]);

  React.useEffect(() => {
    getUploadStatistics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overviewFilters]);

  const onUploadStart = async () => {
    setProcessStarted(true);
    const file: any = acceptedFiles[0];
    if (!_.isEmpty(file)) {
      const fileExtension = "." + file.name.split(/\.(?=[^\.]+$)/)[1];
      const prefix = file.name.split(/\.(?=[^\.]+$)/)[0];
      const fileName = `${prefix}_${
        account?.name
      }_${new Date().getTime()}${fileExtension}`;
      var blob = file.slice(0, file.size, file.type);
      var newFile = new File([blob], fileName, { type: file.type });

      // 1. Fetch S3 Presigned URL
      try {
        const presignedURLRes = await getS3PresignedURL({
          uploadedBy: account?.name || "",
          filePath: `unfi-uploads/${fileName}`,
          IsImage: "0",
        });
        if (presignedURLRes?.statusCode === 200) {
          // 2. Upload file using Presigned URL
          try {
            const uploadURL = presignedURLRes?.body?.URL;
            await axios.put(uploadURL, newFile, {
              headers: {
                "Content-Type": file.type,
              },
              transformRequest: [(data, headers) => {
                delete headers["Authorization"];
                delete headers["X-Api-Key"];
                return data;
              }],
            });
            setUploadSteps(["Uploaded", "Processing", "Waiting"]);
            setActiveProcessStep(1);
            setFileProcessStatus("Validating");
            setETag(fileName);
            setFileID(fileName);
          } catch (error) {
            console.error("There was an error uploading file: ", error);
          }
        } else {
          setUploadSteps(["Uploading", "Process", "Waiting"]);
          setActiveProcessStep(-1);
          setETag(null);
        }
      } catch (error) {
        console.error("[onUploadStart]: ", error);
      }
    }
  };

  const onDelete = () => {
    setSelectedFile(null);
  };

  const handleUploaderFilterClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorElUploader(event.currentTarget);
    setOpenUploaderFilter((prev) => !prev);
  };

  const handleDateFilterClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorElDate(event.currentTarget);
    setOpenDateFilter((prev) => !prev);
  };

  const handleRangeFilterClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorElRange(event.currentTarget);
    setOpenRangeFilter((prev) => !prev);
  };

  const onUploaderSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tempUploaders = _.clone(uploaders);
    if (event.target.value) {
      const filteredUploaders = tempUploaders.filter((v: string) =>
        v.toLowerCase().includes(event.target.value.toLowerCase())
      );
      setFilteredUploaders(filteredUploaders);
    } else {
      setFilteredUploaders(tempUploaders);
    }
  };

  const handleUploaderChange = (value: string) => () => {
    const currentIndex = selectedUploaders.indexOf(value);
    const newChecked = [...selectedUploaders];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    if (newChecked.length > 0 && newChecked.indexOf("All Users") === -1) {
      setUploadFilters({
        ...uploadFilters,
        UploadedBy: newChecked,
      });
    } else {
      setUploadFilters({});
    }
    setSelectedUploaders(newChecked);
  };

  const isStepFailed = (step: number) => {
    return step === 2 && uploadSteps[2] === ERROR_STATUS;
  };

  const handleClickAway = () => {
    setOpenUploaderFilter(false);
    setFilteredUploaders(uploaders);
  };

  const onStartDateChange = (newDate: any) => {
    setStartDate({ ...startDate, date: newDate });
    setEndDate({ ...endDate, minDate: newDate });
    if (newDate && endDate.date) {
      setUploadFilters({
        ...uploadFilters,
        StartDate: format(newDate, "MM/dd/yyyy"),
        EndDate: format(endDate.date, "MM/dd/yyyy"),
      });
    }
  };

  const onEndDateChange = (newDate: any) => {
    setEndDate({ ...endDate, date: newDate });
    setStartDate({ ...startDate, maxDate: newDate });
    if (startDate.date && newDate) {
      setUploadFilters({
        ...uploadFilters,
        StartDate: format(startDate.date, "MM/dd/yyyy"),
        EndDate: format(newDate, "MM/dd/yyyy"),
      });
    }
  };

  const handleRangeClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    switch (index) {
      case 0:
        // Last 7 Days
        setOverviewFilters({
          StartDate: format(Date.now() - 7 * 24 * 60 * 60 * 1000, "MM/dd/yyyy"),
          EndDate: format(new Date(), "MM/dd/yyyy"),
        });
        setRangeLabel(
          `${format(
            Date.now() - 7 * 24 * 60 * 60 * 1000,
            "MMM d, yyyy"
          )} - ${format(new Date(), "MMM d, yyyy")}`
        );
        break;
      case 1:
        // Last 30 Days
        setOverviewFilters({
          StartDate: format(
            Date.now() - 30 * 24 * 60 * 60 * 1000,
            "MM/dd/yyyy"
          ),
          EndDate: format(new Date(), "MM/dd/yyyy"),
        });
        setRangeLabel(
          `${format(
            Date.now() - 30 * 24 * 60 * 60 * 1000,
            "MMM d, yyyy"
          )} - ${format(new Date(), "MMM d, yyyy")}`
        );
        break;
      case 2:
        // This Month
        setOverviewFilters({
          StartDate: format(startOfMonth(new Date()), "MM/dd/yyyy"),
          EndDate: format(endOfMonth(new Date()), "MM/dd/yyyy"),
        });
        setRangeLabel(
          `${format(startOfMonth(new Date()), "MMM d, yyyy")} - ${format(
            endOfMonth(new Date()),
            "MMM d, yyyy"
          )}`
        );
        break;
      case 3:
        // Last Month
        const date = new Date();
        setOverviewFilters({
          StartDate: format(
            new Date(date.getFullYear(), date.getMonth() - 1, 1),
            "MM/dd/yyyy"
          ),
          EndDate: format(
            new Date(date.getFullYear(), date.getMonth(), 0),
            "MM/dd/yyyy"
          ),
        });
        setRangeLabel(
          `${format(
            new Date(date.getFullYear(), date.getMonth() - 1, 1),
            "MMM d, yyyy"
          )} - ${format(
            new Date(date.getFullYear(), date.getMonth(), 0),
            "MMM d, yyyy"
          )}`
        );
        break;

      default:
        break;
    }
    setSelectedRange(index);
    setOpenRangeFilter(false);
  };

  const onUploadProceed = async () => {
    setProcessLoading(true);
    const res = await proceedUpload({ FileId: fileID });
    if (res?.body === "Success") {
      setETag(fileID);
    }
  };

  const resetState = () => {
    setSelectedFile(null);
    setProcessStarted(false);
    setUploadSteps(["Uploading", "Process", "Waiting"]);
    setActiveProcessStep(-1);
    setETag(null);
    setFileProcessStatus("Started");
    setProcessRemarks({
      errors: [],
      warnings: [],
    });
    setProcessStatistics({
      totalRecords: "0",
      validRecords: "0",
      otherRecords: "0",
    });
    setFileID(null);
    setEnqueuePos(0);
    setIsSourceFile(true);
    setProcessLoading(false);
  };

  return (
    <Box sx={PRODUCT_WRAPPER}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        flex={1}
        spacing={2}
        height={"100%"}
      >
        <Stack sx={UPLOAD_DATA_CONTAINER} spacing={2}>
          <Stack spacing={3}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Stack spacing={0.5}>
                <Typography sx={UPLOAD_TITLE}>Overview</Typography>
                <Typography sx={UPLOAD_OVERVIEW_CAPTION}>
                  {rangeLabel}
                </Typography>
              </Stack>
              <Button
                variant="outlined"
                sx={UPLOAD_FILTER_BUTTON}
                startIcon={
                  <CalendarTodayOutlined
                    style={{ color: "#6F7784", fontSize: 14 }}
                  />
                }
                endIcon={<ArrowDropDown sx={{ color: "#6F7784" }} />}
                onClick={handleRangeFilterClick}
              >
                {RANGE_LIST[selectedRange]}
              </Button>
            </Stack>
            {isOverviewLoading ? (
              <Stack
                justifyContent={"center"}
                alignItems={"center"}
                height={74}
              >
                <CircularProgress sx={{ color: "#276B8B" }} />
                <Typography sx={{ color: "#276B8B" }} variant="body2">
                  {LOCALE.loadingData}
                </Typography>
              </Stack>
            ) : (
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                flex={1}
              >
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  flex={1}
                  paddingX={2}
                >
                  <Stack spacing={2}>
                    <img src={FILES_ICON} alt="user" height={60} width={60} />
                    <Stack spacing={1}>
                      <Typography sx={USER_MENU_ITEM}>
                        Total Files Processed
                      </Typography>
                      <Typography sx={UPLOAD_TITLE}>
                        {overviewFile.total}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack spacing={1} alignItems={"center"}>
                    <Stack height={110}>
                      <Bar
                        options={BAR_CHART_OPTIONS}
                        data={{
                          datasets: [
                            {
                              data: overviewFile?.data,
                              backgroundColor: "#F0F7EC",
                              hoverBackgroundColor: "#077942",
                            },
                          ],
                        }}
                      />
                    </Stack>
                    {overviewFile?.comparison && (
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        bgcolor={
                          overviewFile?.comparison?.flag === "UP"
                            ? "#E7F3ED"
                            : "#F8E6EA"
                        }
                        borderRadius={"4px"}
                        padding={"4px 12px"}
                        spacing={1}
                      >
                        {overviewFile?.comparison?.flag === "UP" ? (
                          <TrendingUp sx={{ fontSize: 12, color: "#077942" }} />
                        ) : (
                          <TrendingDown
                            sx={{ fontSize: 12, color: "#B80530" }}
                          />
                        )}
                        <Typography
                          sx={{
                            fontSize: 12,
                            lineHeight: "16px",
                            fontWeight: 500,
                            color:
                              overviewFile?.comparison?.flag === "UP"
                                ? "#077942"
                                : "#B80530",
                          }}
                        >
                          {`vs ${RANGE_LIST[selectedRange]}: ${overviewFile?.comparison.value}`}
                        </Typography>
                      </Stack>
                    )}
                  </Stack>
                </Stack>
                <Divider
                  orientation="vertical"
                  sx={{
                    borderColor: "rgba(15, 61, 97, 0.08)",
                  }}
                />
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  flex={1}
                  paddingX={2}
                >
                  <Stack spacing={2}>
                    <img src={RECORDS_ICON} alt="user" height={60} width={60} />
                    <Stack spacing={1}>
                      <Typography sx={USER_MENU_ITEM}>
                        Records Processed
                      </Typography>
                      <Typography sx={UPLOAD_TITLE}>
                        {overviewUPC.total}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    spacing={1}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Stack height={110}>
                      <Bar
                        options={BAR_CHART_OPTIONS}
                        data={{
                          datasets: [
                            {
                              data: overviewUPC?.data,
                              backgroundColor: "#F0F7EC",
                              hoverBackgroundColor: "#077942",
                            },
                          ],
                        }}
                      />
                    </Stack>
                    {overviewUPC?.comparison && (
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        bgcolor={
                          overviewUPC?.comparison?.flag === "UP"
                            ? "#E7F3ED"
                            : "#F8E6EA"
                        }
                        borderRadius={"4px"}
                        padding={"4px 12px"}
                        spacing={1}
                      >
                        {overviewUPC?.comparison?.flag === "UP" ? (
                          <TrendingUp sx={{ fontSize: 12, color: "#077942" }} />
                        ) : (
                          <TrendingDown
                            sx={{ fontSize: 12, color: "#B80530" }}
                          />
                        )}
                        <Typography
                          sx={{
                            fontSize: 12,
                            lineHeight: "16px",
                            fontWeight: 500,
                            color:
                              overviewUPC?.comparison?.flag === "UP"
                                ? "#077942"
                                : "#B80530",
                          }}
                        >
                          {`vs ${RANGE_LIST[selectedRange]}: ${overviewUPC?.comparison.value}`}
                        </Typography>
                      </Stack>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            )}
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              marginTop={4}
            >
              <Button
                variant="outlined"
                endIcon={<East />}
                sx={UPLOAD_NAVIGATION_BTN_ALT}
                onClick={() => navigate(ROUTES.PRODUCTS)}
              >
                View Product Catalog
              </Button>
            </Stack>
          </Stack>

          <Divider
            style={{
              borderColor: "rgba(15, 61, 97, 0.08)",
              marginTop: 24,
              marginBottom: 8,
            }}
          />

          <Stack spacing={2} flex={1} overflow={"hidden"}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography sx={UPLOAD_SUBTITLE}>
                {LOCALE.uploadedFiles}
              </Typography>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Button
                  variant="outlined"
                  sx={UPLOAD_FILTER_BUTTON}
                  endIcon={<ArrowDropDown sx={{ color: "#6F7784" }} />}
                  onClick={handleUploaderFilterClick}
                >
                  Uploaded by
                </Button>
                <Button
                  variant="outlined"
                  sx={UPLOAD_FILTER_BUTTON}
                  endIcon={<ArrowDropDown sx={{ color: "#6F7784" }} />}
                  onClick={handleDateFilterClick}
                >
                  By date
                </Button>
              </Stack>
            </Stack>
            {isLoading ? (
              <Stack
                justifyContent={"center"}
                alignItems={"center"}
                height={250}
              >
                <CircularProgress sx={{ color: "#276B8B" }} />
                <Typography sx={{ color: "#276B8B" }} variant="body2">
                  {LOCALE.loadingData}
                </Typography>
              </Stack>
            ) : (
              <>
                {uploadedFiles.length > 0 ? (
                  <List sx={{ overflowY: "auto" }}>
                    {uploadedFiles.map((uf: any, index: number) => (
                      <ListItem
                        key={`uploaded_files${index}`}
                        sx={{
                          border: "1px solid #F1F2F3",
                          borderRadius: "8px",
                          padding: "11px 16px",
                          marginBottom: 1,
                          flex: 1,
                        }}
                      >
                        <Stack direction={"row"} flex={1} spacing={2}>
                          <img
                            src={
                              uf.FileName.includes("csv")
                                ? CSV_ICON
                                : EXCEL_ICON
                            }
                            alt={uf.FileName.includes("csv") ? "csv" : "xls"}
                            height={32}
                          />
                          <Stack>
                            <Typography sx={UPLOAD_FILE_NAME}>
                              {uf?.FileName || ""}
                            </Typography>
                            <Typography sx={UPLOAD_FILE_SIZE}>
                              {uf?.FileSize ? `${uf?.FileSize / 1000} KB` : ""}
                            </Typography>
                          </Stack>
                        </Stack>
                        <Stack direction={"row"} flex={1} spacing={1.5}>
                          <Divider
                            orientation="vertical"
                            sx={{
                              borderColor: "rgba(15, 61, 97, 0.08)",
                              height: "auto",
                            }}
                          />
                          <img src={UPLOAD_ICON} alt="upload" height={32} />
                          <Stack spacing={0.25}>
                            <Typography sx={UPLOAD_CAPTION}>
                              {"Posted on"}
                            </Typography>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={2}
                            >
                              <Typography
                                sx={{
                                  ...UPLOAD_CAPTION,
                                  color: "#282C36",
                                }}
                              >
                                {isValid(new Date(uf.FileUploadDateTime))
                                  ? format(
                                      new Date(uf.FileUploadDateTime),
                                      "MMM dd, yyyy HH:mm"
                                    )
                                  : ""}
                              </Typography>
                              <Divider
                                orientation="vertical"
                                sx={{
                                  borderColor: "rgba(15, 61, 97, 0.08)",
                                  marginRight: 1,
                                }}
                              />
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                spacing={0.5}
                              >
                                <Typography sx={UPLOAD_CAPTION}>by</Typography>
                                <Typography
                                  sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}
                                >
                                  {uf.UploadedBy || ""}
                                </Typography>
                              </Stack>
                            </Stack>
                          </Stack>
                        </Stack>
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    marginTop={5}
                  >
                    <Typography>No files found!</Typography>
                  </Stack>
                )}
              </>
            )}
          </Stack>
        </Stack>
        <Stack sx={UPLOAD_CONTAINER}>
          <Typography sx={UPLOAD_SUBTITLE}>{LOCALE.upload}</Typography>
          <Box
            sx={{
              ...DROPZONE_WRAPPER,
              minHeight:
                enqueuedFiles.length > 0 ? 104 : selectedFile ? 284 : 434,
            }}
          >
            {selectedFile ? (
              <Stack sx={DROPZONE_FILE} spacing={2}>
                <Stack direction={"row"} spacing={2}>
                  <img
                    src={
                      selectedFile.type.includes("csv") ? CSV_ICON : EXCEL_ICON
                    }
                    alt={selectedFile.type.includes("csv") ? "csv" : "xls"}
                    height={32}
                  />
                  <Stack>
                    <Typography sx={UPLOAD_FILE_NAME}>
                      {selectedFile.path || ""}
                    </Typography>
                    <Typography sx={UPLOAD_FILE_SIZE}>
                      {selectedFile.size
                        ? `${selectedFile.size / 1000} KB`
                        : ""}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack spacing={1} direction={"row"} alignItems={"center"}>
                  <Stack direction={"row"} alignItems={"center"} spacing={0.5}>
                    <Typography sx={UPLOAD_CAPTION}>Added on:</Typography>
                    <Typography sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}>
                      {format(new Date(), "MMM dd, yyyy HH:mm")}
                    </Typography>
                  </Stack>

                  <Divider
                    orientation="vertical"
                    sx={{ borderColor: "rgba(15, 61, 97, 0.08)" }}
                  />
                  <Stack direction={"row"} alignItems={"center"} spacing={0.5}>
                    <Typography sx={UPLOAD_CAPTION}>by</Typography>
                    <Typography sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}>
                      {account.name || ""}
                    </Typography>
                  </Stack>
                </Stack>
                {!processStarted ? (
                  <Stack spacing={3}>
                    <Stack
                      direction={"row"}
                      spacing={2}
                      sx={UPLOAD_INFO_WRAPPER}
                    >
                      <InfoOutlined sx={{ fontSize: 24, color: "#7B31D8" }} />
                      <Stack spacing={1}>
                        <Typography
                          sx={{
                            ...UPLOAD_CAPTION,
                            color: "#282C36",
                            fontWeight: 600,
                          }}
                        >
                          Uploading a new file
                        </Typography>
                        <Typography
                          sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}
                        >
                          {
                            "Click on the start button to process the file. Once the file gets processed, the user can't delete or edit the file. "
                          }
                        </Typography>
                      </Stack>
                    </Stack>
                    <Stack direction={"row"} alignItems={"center"} spacing={1}>
                      <IconButton
                        aria-label="delete"
                        sx={UPLOAD_DEL_BTN}
                        onClick={onDelete}
                      >
                        <img src={TRASH_ICON} height={20} alt="delete" />
                      </IconButton>
                      <Button
                        variant="contained"
                        sx={UPLOAD_BUTTON}
                        onClick={onUploadStart}
                      >
                        {LOCALE.start}
                      </Button>
                    </Stack>
                  </Stack>
                ) : (
                  <Stack>
                    {/* 1. Validating */}
                    {(fileProcessStatus === "Started" ||
                      fileProcessStatus === "Validating") && (
                      <Stack spacing={3} alignItems={"center"}>
                        <Stack
                          direction={"row"}
                          spacing={1}
                          alignItems={"center"}
                          sx={UPLOAD_WARNING_WRAPPER}
                        >
                          <WarningAmber
                            sx={{ fontSize: 24, color: "#B04509" }}
                          />
                          <Stack spacing={1}>
                            <Typography
                              sx={{
                                ...UPLOAD_CAPTION,
                                color: "#B04509",
                                fontWeight: 600,
                              }}
                            >
                              {fileProcessStatus === "Validating"
                                ? "Validation is in progress."
                                : "File is under process"}
                            </Typography>
                            {fileProcessStatus === "Started" && (
                              <Typography
                                sx={{ ...UPLOAD_CAPTION, color: "#B04509" }}
                              >
                                {"Only a single file can be processed. "}
                              </Typography>
                            )}
                          </Stack>
                        </Stack>
                        <img src={UPLOAD_GIF} alt={"upload"} width={250} />
                      </Stack>
                    )}
                    {/* 2. Validated */}
                    {fileProcessStatus === "Validated" && (
                      <>
                        {processRemarks.errors.length === 0 ? (
                          <Stack spacing={1.5}>
                            <Stack
                              direction={"row"}
                              spacing={1}
                              alignItems={"center"}
                              sx={UPLOAD_SUCCESS_WRAPPER}
                            >
                              <CheckCircle
                                sx={{ fontSize: 24, color: "#077942" }}
                              />
                              <Stack spacing={1}>
                                <Typography
                                  sx={{
                                    ...UPLOAD_CAPTION,
                                    color: "#282C36",
                                    fontWeight: 600,
                                  }}
                                >
                                  Validation is successful.
                                </Typography>
                              </Stack>
                            </Stack>
                            {processRemarks.warnings.length > 0 && (
                              <Stack
                                sx={{
                                  background: "rgba(250, 243, 227, 0.74)",
                                  borderRadius: "4px",
                                  padding: 2,
                                }}
                                spacing={1}
                              >
                                <Stack
                                  direction={"row"}
                                  justifyContent={"space-between"}
                                  sx={{
                                    borderBottom: "1px solid #FFFFFF",
                                    paddingBottom: 2,
                                  }}
                                >
                                  <Stack spacing={1}>
                                    <Typography
                                      sx={{
                                        ...UPLOAD_CAPTION,
                                        color: "#282C36",
                                      }}
                                    >
                                      Total #of Records
                                    </Typography>
                                    <Typography sx={UPLOAD_SUBTITLE}>
                                      {processStatistics.totalRecords || "0"}
                                    </Typography>
                                  </Stack>
                                  <Stack
                                    spacing={1}
                                    sx={{
                                      borderLeft: "1px solid #FFFFFF",
                                      borderRight: "1px solid #FFFFFF",
                                      paddingX: 2,
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        ...UPLOAD_CAPTION,
                                        color: "#282C36",
                                      }}
                                    >
                                      Valid Records
                                    </Typography>
                                    <Typography sx={UPLOAD_SUBTITLE}>
                                      {processStatistics.validRecords || "0"}
                                    </Typography>
                                  </Stack>
                                  <Stack spacing={1}>
                                    <Typography
                                      sx={{
                                        ...UPLOAD_CAPTION,
                                        color: "#282C36",
                                      }}
                                    >
                                      Other Records
                                    </Typography>
                                    <Typography sx={UPLOAD_SUBTITLE}>
                                      {processStatistics.otherRecords || "0"}
                                    </Typography>
                                  </Stack>
                                </Stack>
                                <Stack spacing={2}>
                                  <Stack
                                    direction={"row"}
                                    spacing={1.5}
                                    alignItems={"center"}
                                  >
                                    <WarningAmber
                                      sx={{ fontSize: 24, color: "#B04509" }}
                                    />
                                    <Typography
                                      sx={{
                                        ...UPLOAD_CAPTION,
                                        color: "#B04509",
                                        fontWeight: 600,
                                      }}
                                    >
                                      Warning
                                    </Typography>
                                  </Stack>
                                  <Stack spacing={1} paddingLeft={4}>
                                    {processRemarks.warnings.map(
                                      (w: string, i: number) => (
                                        <Stack
                                          direction={"row"}
                                          alignItems={"center"}
                                          spacing={1}
                                          key={`warning_${i}`}
                                        >
                                          <ErrorOutline
                                            sx={{
                                              fontSize: 24,
                                              color: "#B04509",
                                            }}
                                          />
                                          <Typography
                                            sx={{
                                              ...UPLOAD_CAPTION,
                                              color: "#B04509",
                                            }}
                                          >
                                            {w}
                                          </Typography>
                                        </Stack>
                                      )
                                    )}
                                  </Stack>
                                </Stack>
                              </Stack>
                            )}
                            {!processLoading ? (
                              <Stack marginTop={"12px"} spacing={2}>
                                <Typography
                                  sx={{
                                    ...UPLOAD_CAPTION,
                                    color: "#282C36",
                                    fontWeight: 600,
                                  }}
                                >
                                  Would you like to proceed with upload?
                                </Typography>
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  spacing={1.5}
                                >
                                  <Button
                                    variant="outlined"
                                    sx={UPLOAD_CANCEL_BTN}
                                    onClick={resetState}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    sx={UPLOAD_YES_BTN}
                                    onClick={onUploadProceed}
                                  >
                                    Yes
                                  </Button>
                                </Stack>
                              </Stack>
                            ) : (
                              <Stack
                                direction={"row"}
                                justifyContent={"center"}
                                alignItems={"center"}
                                width={"100%"}
                              >
                                <img
                                  src={UPLOAD_GIF}
                                  alt={"upload"}
                                  width={250}
                                />
                              </Stack>
                            )}
                          </Stack>
                        ) : (
                          <Stack spacing={3}>
                            <Stack
                              sx={{
                                background: "rgba(248, 230, 234, 0.74)",
                                borderRadius: "4px",
                                padding: 2,
                              }}
                              spacing={1}
                            >
                              <Stack
                                direction={"row"}
                                spacing={1.5}
                                alignItems={"center"}
                              >
                                <Error
                                  sx={{ fontSize: 24, color: "#CE0636" }}
                                />
                                <Stack spacing={0.5}>
                                  <Typography
                                    sx={{
                                      ...UPLOAD_CAPTION,
                                      color: "#B80530",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Validation results are in error.
                                  </Typography>
                                  <Typography
                                    sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}
                                  >
                                    {
                                      "Please re-upload the file after incorporating the changes."
                                    }
                                  </Typography>
                                </Stack>
                              </Stack>
                              <Stack spacing={1} paddingLeft={4}>
                                {processRemarks.errors.map(
                                  (err: string, i: number) => (
                                    <Stack
                                      direction={"row"}
                                      alignItems={"center"}
                                      spacing={1}
                                      key={`error_${i}`}
                                    >
                                      <ErrorOutline
                                        sx={{
                                          fontSize: 24,
                                          color: "#B80530",
                                        }}
                                      />
                                      <Typography
                                        sx={{
                                          ...UPLOAD_CAPTION,
                                          color: "#B80530",
                                        }}
                                      >
                                        {err}
                                      </Typography>
                                    </Stack>
                                  )
                                )}
                              </Stack>
                            </Stack>
                            <Stack marginTop={"12px"} spacing={2}>
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                spacing={1.5}
                              >
                                <Button
                                  variant="outlined"
                                  sx={UPLOAD_CANCEL_BTN}
                                  onClick={resetState}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="outlined"
                                  sx={UPLOAD_YES_BTN}
                                  onClick={resetState}
                                  startIcon={<CloudUploadOutlined />}
                                >
                                  Upload a new file
                                </Button>
                              </Stack>
                            </Stack>
                          </Stack>
                        )}
                      </>
                    )}
                    {/* 3. Waiting */}
                    {fileProcessStatus === "Waiting" &&
                      enqueuePos > 0 &&
                      isSourceFile && (
                        <Stack spacing={3}>
                          <Stack
                            sx={{
                              background: "rgba(250, 243, 227, 0.74)",
                              borderRadius: "4px",
                              padding: "12px 16px",
                            }}
                            spacing={1.5}
                          >
                            <Stack
                              direction={"row"}
                              spacing={1.5}
                              alignItems={"center"}
                            >
                              <DynamicFeed
                                sx={{ fontSize: 24, color: "#B04509" }}
                              />
                              <Stack spacing={0.5}>
                                <Typography
                                  sx={{
                                    ...UPLOAD_CAPTION,
                                    color: "#B04509",
                                    fontWeight: 600,
                                  }}
                                >
                                  {`Your file is in the Queue at the ${ordinalSuffixOf(
                                    enqueuePos
                                  )} position`}
                                </Typography>
                                <Typography
                                  sx={{
                                    ...UPLOAD_CAPTION,
                                    color: "#B04509",
                                  }}
                                >
                                  {`Only a single file can be processed.`}
                                </Typography>
                              </Stack>
                            </Stack>
                            <Stack
                              sx={{
                                padding: 1,
                                borderTop: "1px solid #FFFFFF",
                              }}
                              spacing={0.5}
                              alignItems={"center"}
                            >
                              <Typography
                                sx={{
                                  fontSize: 20,
                                  lineHeight: "27px",
                                  color: "#282C36",
                                  fontWeight: 600,
                                }}
                              >
                                {`Enqueue no.${enqueuePos}`}
                              </Typography>
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                spacing={1}
                              >
                                {(enqueuePos >= 4
                                  ? [enqueuePos, enqueuePos - 1, enqueuePos - 2]
                                  : [3, 2, 1]
                                ).map((no: number, numberIndex: number) => (
                                  <Box
                                    key={numberIndex}
                                    sx={{
                                      ...ENQUEUE_NUMBER,
                                      border:
                                        enqueuePos === no
                                          ? "none"
                                          : "1px solid rgba(111, 119, 132, 0.74)",
                                      background:
                                        enqueuePos === no
                                          ? "#25728A"
                                          : "transparent",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: 14,
                                        lineHeight: "19px",
                                        fontWeight: 500,
                                        color:
                                          enqueuePos === no
                                            ? "#FFFFFF"
                                            : "#6F7784",
                                      }}
                                    >
                                      {no}
                                    </Typography>
                                  </Box>
                                ))}
                              </Stack>
                            </Stack>
                          </Stack>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            spacing={1}
                          >
                            <Button
                              variant="outlined"
                              startIcon={<CloudUploadOutlined />}
                              sx={UPLOAD_RESET_BTN}
                              onClick={resetState}
                            >
                              Upload a new file
                            </Button>
                            <Button
                              variant="outlined"
                              endIcon={<East />}
                              sx={UPLOAD_NAVIGATION_BTN_ALT}
                              style={{ height: 34, borderRadius: "4px" }}
                              onClick={() => navigate(ROUTES.PRODUCTS)}
                            >
                              View Product Catalog
                            </Button>
                          </Stack>
                        </Stack>
                      )}
                    {(fileProcessStatus === "Processing" ||
                      fileProcessStatus === "Completed" ||
                      fileProcessStatus === "Error") && (
                      <Stack spacing={3} alignItems={"center"}>
                        {fileProcessStatus === "Processing" && (
                          <Stack
                            direction={"row"}
                            spacing={1}
                            alignItems={"center"}
                            sx={UPLOAD_WARNING_WRAPPER}
                          >
                            <WarningAmber
                              sx={{ fontSize: 24, color: "#B04509" }}
                            />
                            <Stack spacing={1}>
                              <Typography
                                sx={{
                                  ...UPLOAD_CAPTION,
                                  color: "#B04509",
                                  fontWeight: 600,
                                }}
                              >
                                {"File is under process"}
                              </Typography>
                              <Typography
                                sx={{ ...UPLOAD_CAPTION, color: "#B04509" }}
                              >
                                {"Only a single file can be processed. "}
                              </Typography>
                            </Stack>
                          </Stack>
                        )}
                        <Stack
                          direction={"column"}
                          alignItems={"center"}
                          flex={1}
                          spacing={3}
                          sx={{ width: "100%", paddingTop: 1 }}
                        >
                          <Stepper
                            alternativeLabel
                            activeStep={activeProcessStep}
                            connector={<QontoConnector />}
                            sx={{ width: "100%" }}
                          >
                            {uploadSteps.map((label, index) => {
                              if (index === 2) {
                                return (
                                  <Step
                                    key={label}
                                    completed={label === SUCCESS_STATUS}
                                  >
                                    <StepLabel
                                      StepIconComponent={QontoStepIcon}
                                      error={isStepFailed(index)}
                                    >
                                      {label}
                                    </StepLabel>
                                  </Step>
                                );
                              } else {
                                return (
                                  <Step key={label}>
                                    <StepLabel
                                      StepIconComponent={QontoStepIcon}
                                      error={isStepFailed(index)}
                                    >
                                      {label}
                                    </StepLabel>
                                  </Step>
                                );
                              }
                            })}
                          </Stepper>

                          {activeProcessStep === 2 ? (
                            uploadSteps[2] === SUCCESS_STATUS ? (
                              <img
                                src={SUCCESS_GIF}
                                alt={"upload"}
                                width={230}
                              />
                            ) : uploadSteps[2] === ERROR_STATUS ? (
                              <img src={ERROR_GIF} alt={"upload"} width={130} />
                            ) : (
                              <img
                                src={UPLOAD_GIF}
                                alt={"upload"}
                                width={250}
                              />
                            )
                          ) : (
                            <img src={UPLOAD_GIF} alt={"upload"} width={250} />
                          )}
                          {uploadSteps[2] === ERROR_STATUS && (
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#ED4C78",
                                marginY: 3,
                              }}
                            >{`* ${processRemarks.errors[0]}`}</Typography>
                          )}
                          {activeProcessStep === 2 &&
                            uploadSteps[2] !== "Waiting" && (
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                spacing={1}
                              >
                                <Button
                                  variant="outlined"
                                  startIcon={<CloudUploadOutlined />}
                                  sx={UPLOAD_RESET_BTN}
                                  onClick={resetState}
                                >
                                  Upload a new file
                                </Button>
                                <Button
                                  variant="outlined"
                                  endIcon={<East />}
                                  sx={UPLOAD_NAVIGATION_BTN_ALT}
                                  style={{ height: 34, borderRadius: "4px" }}
                                  onClick={() => navigate(ROUTES.PRODUCTS)}
                                >
                                  View Product Catalog
                                </Button>
                              </Stack>
                            )}
                        </Stack>
                      </Stack>
                    )}
                  </Stack>
                )}
              </Stack>
            ) : (
              <Box
                {...getRootProps({
                  className: "dropzone",
                })}
                sx={DROPZONE}
              >
                <input {...getInputProps()} />
                {enqueuedFiles.length > 0 ? (
                  <Stack direction={"row"} spacing={3}>
                    <img src={DATA_GIF} alt={"upload"} height={80} />
                    <Stack justifyContent={"center"} alignItems={"center"}>
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        spacing={0.5}
                      >
                        <Typography
                          sx={{ ...UPLOAD_DROP_TEXT, color: "#0F3D61" }}
                        >
                          Click to upload
                        </Typography>
                        <Typography sx={UPLOAD_DROP_TEXT}>
                          or drag and drop
                        </Typography>
                      </Stack>
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        spacing={1}
                      >
                        <img src={EXCEL_ICON} alt="execl" height={24} />
                        <Typography sx={UPLOAD_DROP_TEXT}>or</Typography>
                        <img src={CSV_ICON} alt="csv" height={24} />
                      </Stack>
                    </Stack>
                  </Stack>
                ) : (
                  <>
                    <img src={DATA_GIF} alt={"upload"} height={160} />
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      spacing={0.5}
                    >
                      <Typography
                        sx={{ ...UPLOAD_DROP_TEXT, color: "#0F3D61" }}
                      >
                        Click to upload
                      </Typography>
                      <Typography sx={UPLOAD_DROP_TEXT}>
                        or drag and drop
                      </Typography>
                    </Stack>

                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      spacing={1}
                      marginTop={1}
                    >
                      <img src={EXCEL_ICON} alt="execl" height={32} />
                      <Typography sx={UPLOAD_DROP_TEXT}>or</Typography>
                      <img src={CSV_ICON} alt="csv" height={32} />
                    </Stack>
                  </>
                )}
              </Box>
            )}
          </Box>
          {!selectedFile && enqueuedFiles.length > 0 && (
            <Stack spacing={2}>
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Typography
                  sx={UPLOAD_SUBTITLE}
                >{`File Enqueued (${enqueuedFiles.length})`}</Typography>
              </Stack>
              <List>
                {enqueuedFiles.map((ef: any, index: number) => (
                  <ListItem
                    key={`enqueued_files${index}`}
                    sx={{
                      border: "1px solid rgba(15, 61, 97, 0.08)",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      marginBottom: 1,
                      flex: 1,
                    }}
                  >
                    <Stack>
                      <Typography sx={UPLOAD_FILE_NAME}>
                        {ef?.FileName || ""}
                      </Typography>
                      <Typography sx={UPLOAD_FILE_SIZE}>
                        {ef?.FileSize ? ef?.FileSize : ""}
                      </Typography>
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        marginTop={1}
                        spacing={2}
                      >
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          spacing={0.5}
                        >
                          <Typography sx={UPLOAD_CAPTION}>Added on:</Typography>
                          <Typography
                            sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}
                          >
                            {isValid(new Date(ef.FileUploadDateTime))
                              ? format(
                                  new Date(ef.FileUploadDateTime),
                                  "MMM dd, yyyy HH:mm"
                                )
                              : ""}
                          </Typography>
                        </Stack>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          spacing={0.5}
                        >
                          <Typography sx={UPLOAD_CAPTION}>by</Typography>
                          <Typography
                            sx={{ ...UPLOAD_CAPTION, color: "#282C36" }}
                          >
                            {ef.UploadedBy || ""}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </ListItem>
                ))}
              </List>
            </Stack>
          )}
        </Stack>
      </Stack>
      <Popper
        open={openUploaderFilter}
        anchorEl={anchorElUploader}
        placement={"bottom-end"}
        transition
        disablePortal
        role={undefined}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper sx={UPLOAD_FILTER_PAPER} elevation={0}>
              <ClickAwayListener onClickAway={handleClickAway}>
                <Stack spacing={1}>
                  <FormControl variant="standard">
                    <BootstrapInput
                      id="search-input"
                      placeholder="Search"
                      onChange={onUploaderSearch}
                    />
                  </FormControl>
                  <List sx={{ height: 140, overflowY: "auto" }} dense>
                    {filteredUploaders.map((up: string, index: number) => {
                      const labelId = `checkbox-list-label-${up}`;
                      return (
                        <ListItem key={`${up}_${index}`} disablePadding>
                          <ListItemButton
                            role={undefined}
                            onClick={handleUploaderChange(up)}
                            dense
                          >
                            <ListItemText
                              id={labelId}
                              sx={UPLOAD_LIST_ITEM}
                              disableTypography
                              primary={up || ""}
                            />
                            <ListItemIcon sx={{ minWidth: 20, height: 20 }}>
                              <Checkbox
                                edge="end"
                                onChange={handleUploaderChange(up)}
                                checked={selectedUploaders.indexOf(up) !== -1}
                                icon={<></>}
                                checkedIcon={
                                  <Done
                                    sx={{ color: "#66A640", fontSize: 16 }}
                                  />
                                }
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </ListItemIcon>
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
                  </List>
                </Stack>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
      <Popper
        open={openDateFilter}
        anchorEl={anchorElDate}
        placement={"bottom-end"}
        transition
        disablePortal
        role={undefined}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper sx={UPLOAD_DATE_FILTER_PAPER} elevation={0}>
              <Stack spacing={1} direction={"row"}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <StaticDatePicker
                    displayStaticWrapperAs="desktop"
                    value={startDate.date}
                    minDate={startDate.minDate}
                    maxDate={startDate.maxDate}
                    onChange={onStartDateChange}
                    renderInput={(params) => <TextField {...params} />}
                    disableFuture
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <StaticDatePicker
                    displayStaticWrapperAs="desktop"
                    value={endDate.date}
                    minDate={endDate.minDate}
                    maxDate={endDate.maxDate}
                    onChange={onEndDateChange}
                    renderInput={(params) => <TextField {...params} />}
                    disableFuture
                  />
                </LocalizationProvider>
              </Stack>
            </Paper>
          </Fade>
        )}
      </Popper>
      <Popper
        open={openRangeFilter}
        anchorEl={anchorElRange}
        placement={"bottom-end"}
        transition
        disablePortal
        role={undefined}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper sx={UPLOAD_DATE_FILTER_PAPER} elevation={0}>
              <ClickAwayListener onClickAway={() => {}}>
                <Stack spacing={1}>
                  <List dense>
                    <ListItemButton
                      dense
                      selected={selectedRange === 0}
                      onClick={(event) => handleRangeClick(event, 0)}
                    >
                      <ListItemText
                        sx={UPLOAD_LIST_ITEM}
                        disableTypography
                        primary={RANGE_LIST[0]}
                      />
                    </ListItemButton>
                    <ListItemButton
                      dense
                      selected={selectedRange === 1}
                      onClick={(event) => handleRangeClick(event, 1)}
                    >
                      <ListItemText
                        sx={UPLOAD_LIST_ITEM}
                        disableTypography
                        primary={RANGE_LIST[1]}
                      />
                    </ListItemButton>
                    <ListItemButton
                      dense
                      selected={selectedRange === 2}
                      onClick={(event) => handleRangeClick(event, 2)}
                    >
                      <ListItemText
                        sx={UPLOAD_LIST_ITEM}
                        disableTypography
                        primary={RANGE_LIST[2]}
                      />
                    </ListItemButton>
                    <ListItemButton
                      dense
                      selected={selectedRange === 3}
                      onClick={(event) => handleRangeClick(event, 3)}
                    >
                      <ListItemText
                        sx={UPLOAD_LIST_ITEM}
                        disableTypography
                        primary={RANGE_LIST[3]}
                      />
                    </ListItemButton>
                    {/* <ListItemButton
                      dense
                      selected={selectedRange === 4}
                      onClick={(event) => handleRangeClick(event, 4)}
                    >
                      <ListItemText
                        sx={UPLOAD_LIST_ITEM}
                        disableTypography
                        primary={RANGE_LIST[4]}
                      />
                    </ListItemButton> */}
                  </List>
                </Stack>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </Box>
  );
};

export default Upload;
